module.exports = __webpack_public_path__ + "static/media/covidmunicipal.e254821a.pdf";